import { render } from "./ExhibitorCard.vue?vue&type=template&id=0b0b48e6&scoped=true"
import script from "./ExhibitorCard.vue?vue&type=script&lang=js"
export * from "./ExhibitorCard.vue?vue&type=script&lang=js"

import "./ExhibitorCard.vue?vue&type=style&index=0&id=0b0b48e6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b0b48e6"]])

export default __exports__